import { wwtMemo } from '@wwt/custom/wwt'
// TODO: Change to normal path
import { TabSection } from 'libs/pages/room-offer/src/lib/types/TabSectionProps.ts'

import { wwtPerformanceLog } from '@wwt/core/admin'

import { ShowedContentType } from '@/shared/types'

import { useReservationTab } from '../model/useReservationTab.ts'
import { ReservationTabGuestInformation } from './GuestInformation'
import { ReservationTabError } from './ReservationTabError.tsx'
import { ReservationTabSidePanel } from './ReservationTabSidePanel.tsx'
import { ReservationTabSkeleton } from './ReservationTabSkeleton.tsx'

/**
 *
 *
 * @author Ivan Shchedrovskyi
 */
export const ReservationTab = wwtMemo(({ offer }: TabSection) => {
	wwtPerformanceLog('ReservationTab', offer)

	const { showedContentType, reservationData } = useReservationTab(offer)

	if (showedContentType === ShowedContentType.skeleton) {
		return <ReservationTabSkeleton />
	}

	if (
		// TODO: fix ts
		offer === null ||
		// TODO: fix ts
		reservationData === undefined ||
		showedContentType === ShowedContentType.error
	) {
		return <ReservationTabError />
	}

	return (
		<div className="sm:px-4 md:px-0">
			<div className="grid grid-cols-12 gap-y-8 lg:gap-x-4 xl:gap-x-10">
				<ReservationTabGuestInformation
					offer={offer}
					reservation={reservationData}
				/>

				<ReservationTabSidePanel
					offer={offer}
					reservation={reservationData}
				/>
			</div>
		</div>
	)
})
